import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';
import Hero from './components/Hero';
import ProductsPreview from './components/ProductsPreview';
import Gallery from './components/Gallery';
import TrustNumbers from './components/TrustNumbers';
import HowWeWork from './components/HowWeWork';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import ServiceAreas from './components/ServiceAreas';
import CTAForm from './components/CTAForm';

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="pb-16 md:pb-0">
        <Hero />
        <ProductsPreview />
        <Gallery />
        <CTAForm />
        <TrustNumbers />
        <HowWeWork />
        <Reviews />
        <CTAForm />
        <FAQ />
        <ServiceAreas />
        <CTAForm />
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}